/**
 * Lightweight axios client for super-admin routes. Re-uses the same token
 * key as the rest of the app so a single JWT drives every request.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "pmv5_csuite_token";

const client = axios.create({ baseURL: API, timeout: 30000 });

client.interceptors.request.use((cfg) => {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } catch { /* ignore */ }
  return cfg;
});

export default client;
